export const displayAlert = ($form, $target, html) => {
    $target.append(`<div class='alert is-outline is-info' style='display:none;'>
      <i class="icon-exclamation-solid"></i>${html}
    </div>`);
    $form.find(".alert").slideDown();
};
export const destroyAlert = ($form) => {
    const $alert = $form.find('.alert');
    if ($alert.length) {
        $alert.slideUp({
            complete: () => {
                $alert.remove();
            }
        });
    }
};
export const displaySuccess = ($form, $target, message) => {
    displayAlert($form, $target, message);
};
export const displayError = ($form, $target, error) => {
    let errorMessages = error.responseJSON;
    let node = '';
    if (errorMessages) {
        node = `<span>${errorMessages.message}</span>`;
    }
    displayAlert($form, $target, node);
};
export const jsonFormData = (formData) => {
    const object = {};
    formData.forEach((value, key) => object[key] = value);
    return object;
};
